import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const FloatingContact = () => {
  const settings = useSettings();
  const raw = (settings.phone_raw || '').replace('+', '');
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <a href={`https://wa.me/${raw}`} target="_blank" rel="noreferrer" className="group w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl flex items-center justify-center hover:scale-110 transition-transform" aria-label="WhatsApp">
        <MessageCircle size={22} />
      </a>
      <a href={`tel:${settings.phone_raw}`} className="group w-14 h-14 rounded-full bg-[#304b71] text-white shadow-xl flex items-center justify-center hover:scale-110 hover:bg-[#6a8aa4] transition-all" aria-label="Call">
        <Phone size={20} />
      </a>
    </div>
  );
};

export default FloatingContact;
